import React, { Component } from "react";
import TrackVisibility from "react-on-screen";
import content from "./content/content";
import Intro from "./sections/Intro";
import Banner from "./sections/Banner";
import CTA from "./sections/Cta";
import Services from "./sections/Servicios";
import Clients from "./sections/Clientes";
import OtrosServicios from "./sections/OtrosServicios";
import Partners from "./sections/Partners";
import Footer from "./sections/Footer";
import Thanks from "./sections/Thanks";
import Blog from "./sections/Blog";
import RedesButtons from "./components/function/redes/redesButtons";

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  HashRouter
} from "react-router-dom";
import "./App.css";

/*
*Google Analytics
*/
import ReactGA from "react-ga";
ReactGA.initialize("UA-112855311-4");
/** */

class App extends Component {
  Home = () => (
    <div>
      <Intro content={content.intro} />
      <TrackVisibility partialVisibility once>
        {({ isVisible }) => (
          <Banner content={content.banner} visible={isVisible} />
        )}
      </TrackVisibility>
      <TrackVisibility partialVisibility>
        {({ isVisible }) => <CTA content={content.cta} visible={isVisible} />}
      </TrackVisibility>

      <div id="Servicios">
        <TrackVisibility partialVisibility once>
          {({ isVisible }) => (
            <Services content={content.servicios} visible={isVisible} />
          )}
        </TrackVisibility>
      </div>

      <TrackVisibility partialVisibility once>
        {({ isVisible }) => (
          <Clients content={content.clientes} visible={isVisible} />
        )}
      </TrackVisibility>
      <TrackVisibility partialVisibility once>
        {({ isVisible }) => (
          <OtrosServicios
            content={content.otrosservicios}
            visible={isVisible}
          />
        )}
      </TrackVisibility>
      <TrackVisibility partialVisibility once>
        {({ isVisible }) => (
          <Partners content={content.partners} visible={isVisible} />
        )}
      </TrackVisibility>
      <TrackVisibility partialVisibility once>
        {({ isVisible }) => (
          <Footer content={content.footer} visible={isVisible} />
        )}
      </TrackVisibility>
    </div>
  );

  thanks = () => <Thanks />;

  blog = () => <Blog />;

  render() {
    return (
      <HashRouter>
        <div>
          <RedesButtons />
          <Route
            exact
            path="/"
            render={() => (
              <Redirect to="/agencia-de-servicios-digitales-puebla" />
            )}
          />
          <Route
            exact
            path="/agencia-de-servicios-digitales-puebla"
            component={this.Home}
          />
          <Route path="/Gracias" component={this.thanks} />
          <Route path="/Blog" component={this.blog} />
        </div>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js